import $ from 'jquery';
import { mapColumnsConfig } from '@bingads-webui/projection-grid-base-column';
import { EditedByColumn } from './columns/edited-by';
import { NumberOfRecommendationColumn } from './columns/number-of-recommendation';
import { RecommendationTypeColumn } from './columns/recommendation-type';
import { StartTimeColumn } from './columns/start-time';
import { StatusColumn } from './columns/status';
import { RecommendationHistoryGridService } from './grid-service';

const columns = [
  StartTimeColumn,
  RecommendationTypeColumn,
  NumberOfRecommendationColumn,
  EditedByColumn,
  StatusColumn,
];

export function getConfig({
  i18n,
  newI18n,
  el,
  recommendationService,
  appConfig,
  currentActivity,
}) {
  const gridService = new RecommendationHistoryGridService(recommendationService, currentActivity);
  const headRows = [
    'top-filler',
    'column-header-rows',
  ];
  const scrolling = {
    header: {
      type: 'sticky',
      offset: () => $('nav.navbar-default.navbar-fixed-top').height(),
    },
    virtualized: false,
  };

  return {
    name: 'RecommendationResultGrid',
    tableClasses: ['table', 'table-bordered'],
    columns: mapColumnsConfig(columns, {
      i18n,
      newI18n,
      appConfig,
    }),
    plugins: {
      uiBlocker: {
        el,
      },
    },
    rows: {
      headRows,
    },
    dataSource: {
      type: 'js-data',
      entity: gridService,
    },
    scrolling,
  };
}
